import cz from '../csCZ/viewer';

const en: typeof cz = {
	page: 'Page',
	from: 'of',
};

export default en;
